import { Box } from "@material-ui/core";
import { FC } from "react";

const TrainerImage: FC<any> = (props) => {
  return (
    <Box width={75} height={75}>
      {
        <img
          src={props.record?.picture?.src}
          alt={props.record?.displayName?.en}
          width="100%"
          height="100%"
          style={{ borderRadius: "50%" }}
        />
      }
    </Box>
  );
};

export default TrainerImage;
